module.exports = __webpack_public_path__ + "media/assets/date_field-2621c6b31eee4612f8bef5724aa4ab14.svg";